import React from "react";
import {useDarkMode} from "../../contexts/darkModeContext";

const FormSubtext = ({ label }) => {
    
    const { darkMode } = useDarkMode();

    return (
        
        <div className={`sm:col-span-full text-gray-500 -mt-2 justify-center items-center text-end text-xs`}>{label}</div>
    
    );
};

export default FormSubtext;
